import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from 'react';
import { useBoolean } from 'minimal-shared/hooks';
import { isActiveLink, isExternalLink } from 'minimal-shared/utils';
import { usePathname } from 'src/routes/hooks';
import { NavItem } from './nav-item';
import { navSectionClasses } from '../styles';
import { NavUl, NavLi, NavCollapse } from '../components';

// ----------------------------------------------------------------------

export function NavList({
  data,
  depth,
  render,
  slotProps,
  currentRole,
  enabledRootRedirect
}) {
  const pathname = usePathname();
  const navItemRef = useRef(null);
  const isActive = isActiveLink(pathname, data.path, !!data.children);
  const {
    value: open,
    onFalse: onClose,
    onToggle
  } = useBoolean(isActive);
  useEffect(() => {
    if (!isActive) onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // Hidden item by role
  if (data.roles && currentRole && !data.roles.includes(currentRole)) return null;
  const handleToggleMenu = () => data.children && onToggle();
  const renderNavItem = () => <NavItem ref={navItemRef}
  // slots
  path={data.path} icon={data.icon} info={data.info} title={data.title} caption={data.caption}
  // state
  open={open} active={isActive} disabled={data.disabled}
  // options
  depth={depth} render={render} hasChild={!!data.children} externalLink={isExternalLink(data.path)} enabledRootRedirect={enabledRootRedirect}
  // styles
  slotProps={depth === 1 ? slotProps?.rootItem : slotProps?.subItem}
  // actions
  onClick={handleToggleMenu} />;
  const renderCollapse = () => !!data.children && <NavCollapse mountOnEnter unmountOnExit depth={depth} in={open} data-group={data.title}>
        <NavSubList data={data.children} render={render} depth={depth} slotProps={slotProps} currentRole={currentRole} enabledRootRedirect={enabledRootRedirect} />
      </NavCollapse>;
  return <NavLi disabled={data.disabled} sx={{
    ...(!!data.children && {
      [`& .${navSectionClasses.li}`]: {
        '&:first-of-type': {
          mt: 'var(--nav-item-gap)'
        }
      }
    })
  }}>
      {renderNavItem()}
      {renderCollapse()}
    </NavLi>;
}
function NavSubList(t0) {
  const $ = _c(16);
  const {
    data,
    render,
    depth: t1,
    slotProps,
    currentRole,
    enabledRootRedirect
  } = t0;
  const depth = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "var(--nav-item-gap)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== currentRole || $[2] !== data || $[3] !== depth || $[4] !== enabledRootRedirect || $[5] !== render || $[6] !== slotProps) {
    let t4;
    if ($[8] !== currentRole || $[9] !== depth || $[10] !== enabledRootRedirect || $[11] !== render || $[12] !== slotProps) {
      t4 = list => <NavList key={list.title} data={list} render={render} depth={depth + 1} slotProps={slotProps} currentRole={currentRole} enabledRootRedirect={enabledRootRedirect} />;
      $[8] = currentRole;
      $[9] = depth;
      $[10] = enabledRootRedirect;
      $[11] = render;
      $[12] = slotProps;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t3 = data.map(t4);
    $[1] = currentRole;
    $[2] = data;
    $[3] = depth;
    $[4] = enabledRootRedirect;
    $[5] = render;
    $[6] = slotProps;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = <NavUl sx={t2}>{t3}</NavUl>;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}